"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var preventDefault = function preventDefault() {},
    isDefaultPrevented = function isDefaultPrevented() {
  return false;
},
    isPropagationStopped = function isPropagationStopped() {
  return false;
},
    stopPropagation = function stopPropagation() {};

function _default(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$type = options.type,
      type = _options$type === void 0 ? 'change' : _options$type;
  return {
    target: target,
    currentTarget: target,
    preventDefault: preventDefault,
    stopPropagation: stopPropagation,
    type: type,
    bubbles: false,
    cancelable: false,
    defaultPrevented: false,
    isTrusted: true,
    isDefaultPrevented: isDefaultPrevented,
    isPropagationStopped: isPropagationStopped,
    timeStamp: new Date().getTime(),
    nativeEvent: {
      target: target,
      currentTarget: target,
      type: type
    }
  };
}